import { Controller, useFormContext } from "react-hook-form"
import { APPROVAL, convertNumber, useAccounts, useProject, useTaxCode, useToggle } from "utils"
import { BillServiceValues } from "../types"
import { useProductUnit } from "pages/Inventori/Transaction/AddNewItem/components/FormSection/utils"
import { ActionButton, Button, Modal } from "components"
import toast from "react-hot-toast"
import { TableListForm } from "./TableListForm"

type ListSectionProps = {
  index: number, 
  disable?: boolean, 
  onDelete: () => void
}
export const ListSection = ({ index, onDelete, disable }: ListSectionProps) => {
  const { isActive, toggle } = useToggle(false)
  const toggleDelete = useToggle(false)
  const { control, getValues, watch } = useFormContext<BillServiceValues>()

  const dataAccount = useAccounts()
  const dataUnit = useProductUnit("name")
  const dataProject = useProject()
  const dataTaxCode = useTaxCode()

  const isView = watch("approval_status") === APPROVAL.APPROVED || watch("approval_status") === APPROVAL.REJECTED

  return (
    <Controller
      name={`details.${index}` as const}
      control={control}
      render={({ field }) => {
        const values = field?.value

        const getUnitName = dataUnit?.dataUnit?.find(unit => unit?.value === values?.mr_unit_id)?.label
        const getJobName = dataProject?.data?.find(item => item?.value === values?.project_id)?.label
        const getTaxName = dataTaxCode?.data?.find(item => item?.value === values?.tax_id)?.label
        const getAccountName = dataAccount?.data?.find(acc => acc?.value === values?.product_id)?.label

        const matchAccount = getAccountName?.match(/^([\d-]+)\s+(.+)$/)
        const accountCode = matchAccount?.[1]
        const accountName = matchAccount?.[2]

        if (isActive) {
          return (
            <TableListForm
              default_values={values}
              onCancel={toggle}
              onUpdate={res => {
                if (res?.product_id !== values?.product_id && getValues("details").find(item => item?.product_id === res?.product_id)) {
                  return toast.error("The account has already on the detail list")
                }

                field.onChange(res)
                toggle()
              }}
            />
          )
        }

        return (
          <tr>
            <td>{index + 1}</td>
            <td>{accountCode ?? "-"}</td>
            <td>{accountName ?? "-"}</td>
            <td>{values?.description ?? "0"}</td>
            <td>{values?.quantity_order ? convertNumber(values?.quantity_order)?.intoNormalAmount : "0"}</td>
            <td>{getUnitName ?? "0"}</td>
            <td>{values?.price_bill ? convertNumber(values?.price_bill)?.intoCurrency : "0"}</td>
            <td className="text-right">{values?.discount ? convertNumber(values?.discount).intoNormalAmount : "0"}%</td>
            <td className="text-right">{values?.total ? convertNumber(values?.total).intoCurrency : "0"}</td>
            <td>{getJobName ?? "-"}</td>
            <td>{getTaxName ?? "-"}</td>
            {!disable && <td>
              {!isView && (
                <section className="flex justify-center">
                  <ActionButton.Update type="button" onClick={toggle} />
                  <ActionButton.Delete type="button" onClick={toggleDelete.toggle} />
                </section>
              )}
            </td>}

            {toggleDelete.isActive && (
              <Modal isOpen title="DELETE DETAIL BILL SERVICE" closeModal={toggle}>
                <Modal.Body>
                  <div className="text-error">Are you sure want to delete this data?</div>
                </Modal.Body>
      
                <Modal.Footer className="flex justify-end gap-3">
                  <Button
                    color="error"
                    onClick={() => {
                      onDelete()
                      toggleDelete.toggle()
                    }}
                  >
                    DELETE
                  </Button>
      
                  <Button color="ghost" onClick={toggleDelete.toggle}>
                    CANCEL
                  </Button>
                </Modal.Footer>
              </Modal>
            )}
          </tr>
        )
      }}
    />
  )
}